import React from 'react'
import { IsSpecialEmployer } from 'application/helpers'

function InsuranceDisclaimer() {
  let isSAGBYO = IsSpecialEmployer('SAGBYO')

  let ThingsYouNTK = isSAGBYO ? "This general information doesn't take your personal circumstances into account. Please consider whether this information is right for you before making a decision and seek professional independent tax or financial advice. Conditions and fees apply, along with credit assessment criteria for lease products. This availability of benefits is subject to your employer's approval. Maxxia may pay and/or receive commissions in connection with its services.": "This general information doesn't take your personal circumstances into account. Please read the PDS and consider whether this information is right for you before making a decision and seek professional independent tax or financial advice. Conditions and fees apply, along with credit assessment criteria for lease and loan products. This availability of benefits is subject to your employer's approval. Maxxia may receive commissions in connection with its services."

  return global.config.isBrandRS ? (
    <div className="text-smaller">
      <p>
        <strong>
          <span className="text-dark">Insurance</span>
        </strong>
      </p>
      <div>
        If you chose any of the add-on novated lease insurance products, it is
        included in the cost of your lease. You will receive your policy
        document when you enter into your lease. Remuneration Services (Qld)
        (ABN 46 093 173 089) (RemServ) is authorised by:
        <ul>
          <li className="mt-2">
            Allianz Australia Insurance Limited (ABN 15 000 122 850, AFSL
            234708) to provide general advice on and arrange Motor Vehicle Lease
            Insurance issued by Allianz.
          </li>
          <li className="mt-2">
            Pacific International Insurance (ABN 83 169 311 193, AFSL 523921) to
            provide general advice on and arrange Motor Vehicle Lease Insurance
            Options Policy issued by Pacific International Insurance.
          </li>
        </ul>
      </div>
      <p>
        <strong>
          {' '}
          <span className="text-dark">Insurance Disclosures</span>
        </strong>
      </p>
      <p>
        The Product Disclosure Statement (PDS) for each insurance product
        includes the full terms and conditions and the Financial Services Guide
        (FSG) includes information about the financial services RemServ
        provides. The Target Market Determination (TMD) describes the target
        market for each insurance product, the distribution conditions and other
        information about these insurances. You can obtain these documents by
        visiting our{' '}
        <a
          href="https://www.remserv.com.au/insurance/novated-lease#pds"
          className="text-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          website
        </a>{' '}
        or contacting us at 1300 303 940 or{' '}
        <a
          href="mailto:remserv@remserv.com.au"
          className="text-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          remserv@remserv.com.au
        </a>
        .
      </p>
      <p>
        <strong>
          <span className="text-dark">Things you need to know:</span>
        </strong>{' '}
        This general information doesn't take your personal circumstances into
        account. Please read the PDS and consider whether this information is
        right for you before making a decision and seek professional independent
        tax or financial advice. Conditions and fees apply, along with credit
        assessment criteria for lease and loan products. This availability of
        benefits is subject to your employer's approval. RemServ may receive
        commissions in connection with its services.
      </p>
    </div>
  ) : (
    <div className="text-smaller">
      {!isSAGBYO && <div>
        <p>
          <b className="text-dark">Insurance</b>
        </p>
        <div>
          If you chose any of the add-on novated lease insurance products, it is
          included in the cost of your lease. You will receive your policy
          document when you enter into your lease. Maxxia (ABN 39 082 449 036)
          (Maxxia) is authorised by:
          <ul>
            <li className="mt-2">
              Allianz Australia Insurance Limited (ABN 15 000 122 850, AFSL
              234708) to provide general advice on and arrange Motor Vehicle Lease
              Insurance issued by Allianz.{' '}
            </li>
            <li className="mt-2">
              Coverforce Insurance Broking Victoria Pty Limited (ABN 45 127 707
              813, AFSL 345986) to provide general advice on and arrange Lease
              Protection Insurance and Total Loss Assist Insurance issued by
              Professional Risk Underwriting Pty Ltd (ABN 80 103 953 073, AFSL
              308076) and Safeguard Ultimate Warranty and Residual Protection
              Cover issued by Virginia Surety Company, Inc (ABN 080 339 957, AFSL
              245579).
            </li>
            <li className="mt-2">
              Pacific International Insurance (ABN 83 169 311 193, AFSL 523921) to
              provide general advice on and arrange Motor Vehicle Lease Insurance
              Options Policy issued by Pacific International Insurance.
            </li>
          </ul>
        </div>
        <p>
          <b className="text-dark">Insurance Disclosures</b>
        </p>
        <p>
          The Product Disclosure Statement (PDS) for each insurance product
          includes the full terms and conditions and the Financial Services Guide
          (FSG) includes information about the financial services Maxxia provides.
          The Target Market Determination (TMD) describes the target market for
          each insurance product, the distribution conditions and other
          information about these insurances. You can obtain these documents by
          visiting our{' '}
          <strong>
            <a
              href="https://www.maxxia.com.au/insurance/novated-lease#pds"
              className="text-dark text-underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              website
            </a>
          </strong>{' '}
          or contacting us at 1300 123 123 or{' '}
          <strong>
            <a
              href="mailto:mycarassist@maxxia.com.au"
              className="text-dark text-underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              mycarassist@maxxia.com.au
            </a>
          </strong>
          .
        </p>
      </div>
      }
      <p>
        <b className="text-dark">Things you need to know:</b> {ThingsYouNTK}
      </p>
      <p>
        Maxxia collects your personal information from you when you apply for a
        product and request any information from us, and we may use this
        information to contact you about our products, services and offerings.
        To read more about how we handle your personal information, please read
        our{' '}
        <a
          href="https://mmsg.com.au/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-dark text-underline font-weight-bold"
          id="insurancedisclaimer.privacystatement"
        >
          Privacy Statement
        </a>
        .
      </p>
    </div>
  )
}

export default InsuranceDisclaimer
